import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-career-roadmap',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './career-roadmap.component.html',
  styleUrls: ['./career-roadmap.component.scss']
})
export class CareerRoadmapComponent {}
